/**
 * @fileoverview gRPC-Web generated client stub for bish
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: settings/service.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as settings_service_pb from '../settings/service_pb'; // proto import: "settings/service.proto"


export class SettingsClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/bish.Settings/Get',
    grpcWeb.MethodType.UNARY,
    settings_service_pb.GetSettingsRequest,
    settings_service_pb.SettingsSnapshot,
    (request: settings_service_pb.GetSettingsRequest) => {
      return request.serializeBinary();
    },
    settings_service_pb.SettingsSnapshot.deserializeBinary
  );

  get(
    request: settings_service_pb.GetSettingsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<settings_service_pb.SettingsSnapshot>;

  get(
    request: settings_service_pb.GetSettingsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void): grpcWeb.ClientReadableStream<settings_service_pb.SettingsSnapshot>;

  get(
    request: settings_service_pb.GetSettingsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Settings/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Settings/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorRestoreDefaults = new grpcWeb.MethodDescriptor(
    '/bish.Settings/RestoreDefaults',
    grpcWeb.MethodType.UNARY,
    settings_service_pb.RestoreDefaultsRequest,
    settings_service_pb.SettingsSnapshot,
    (request: settings_service_pb.RestoreDefaultsRequest) => {
      return request.serializeBinary();
    },
    settings_service_pb.SettingsSnapshot.deserializeBinary
  );

  restoreDefaults(
    request: settings_service_pb.RestoreDefaultsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<settings_service_pb.SettingsSnapshot>;

  restoreDefaults(
    request: settings_service_pb.RestoreDefaultsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void): grpcWeb.ClientReadableStream<settings_service_pb.SettingsSnapshot>;

  restoreDefaults(
    request: settings_service_pb.RestoreDefaultsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Settings/RestoreDefaults',
        request,
        metadata || {},
        this.methodDescriptorRestoreDefaults,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Settings/RestoreDefaults',
    request,
    metadata || {},
    this.methodDescriptorRestoreDefaults);
  }

  methodDescriptorSet = new grpcWeb.MethodDescriptor(
    '/bish.Settings/Set',
    grpcWeb.MethodType.UNARY,
    settings_service_pb.SetSettingsRequest,
    settings_service_pb.SettingsSnapshot,
    (request: settings_service_pb.SetSettingsRequest) => {
      return request.serializeBinary();
    },
    settings_service_pb.SettingsSnapshot.deserializeBinary
  );

  set(
    request: settings_service_pb.SetSettingsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<settings_service_pb.SettingsSnapshot>;

  set(
    request: settings_service_pb.SetSettingsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void): grpcWeb.ClientReadableStream<settings_service_pb.SettingsSnapshot>;

  set(
    request: settings_service_pb.SetSettingsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: settings_service_pb.SettingsSnapshot) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Settings/Set',
        request,
        metadata || {},
        this.methodDescriptorSet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Settings/Set',
    request,
    metadata || {},
    this.methodDescriptorSet);
  }

  methodDescriptorGetSessionToken = new grpcWeb.MethodDescriptor(
    '/bish.Settings/GetSessionToken',
    grpcWeb.MethodType.UNARY,
    settings_service_pb.GetSessionTokenRequest,
    settings_service_pb.GetSessionTokenResponse,
    (request: settings_service_pb.GetSessionTokenRequest) => {
      return request.serializeBinary();
    },
    settings_service_pb.GetSessionTokenResponse.deserializeBinary
  );

  getSessionToken(
    request: settings_service_pb.GetSessionTokenRequest,
    metadata?: grpcWeb.Metadata | null): Promise<settings_service_pb.GetSessionTokenResponse>;

  getSessionToken(
    request: settings_service_pb.GetSessionTokenRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: settings_service_pb.GetSessionTokenResponse) => void): grpcWeb.ClientReadableStream<settings_service_pb.GetSessionTokenResponse>;

  getSessionToken(
    request: settings_service_pb.GetSessionTokenRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: settings_service_pb.GetSessionTokenResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Settings/GetSessionToken',
        request,
        metadata || {},
        this.methodDescriptorGetSessionToken,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Settings/GetSessionToken',
    request,
    metadata || {},
    this.methodDescriptorGetSessionToken);
  }

  methodDescriptorIsAllowed = new grpcWeb.MethodDescriptor(
    '/bish.Settings/IsAllowed',
    grpcWeb.MethodType.UNARY,
    settings_service_pb.IsAllowedRequest,
    settings_service_pb.IsAllowedResponse,
    (request: settings_service_pb.IsAllowedRequest) => {
      return request.serializeBinary();
    },
    settings_service_pb.IsAllowedResponse.deserializeBinary
  );

  isAllowed(
    request: settings_service_pb.IsAllowedRequest,
    metadata?: grpcWeb.Metadata | null): Promise<settings_service_pb.IsAllowedResponse>;

  isAllowed(
    request: settings_service_pb.IsAllowedRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: settings_service_pb.IsAllowedResponse) => void): grpcWeb.ClientReadableStream<settings_service_pb.IsAllowedResponse>;

  isAllowed(
    request: settings_service_pb.IsAllowedRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: settings_service_pb.IsAllowedResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/bish.Settings/IsAllowed',
        request,
        metadata || {},
        this.methodDescriptorIsAllowed,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/bish.Settings/IsAllowed',
    request,
    metadata || {},
    this.methodDescriptorIsAllowed);
  }

}

